import { createCustomValueByField } from "PFCore/services/admin/custom_fields";
import { MutationOptions } from "PFCore/types/request_options";

import { MutationFnParams, useCustomValueCreate } from "./use_custom_value_create";

export const useCreateCustomValueByField = ({ ...props }: MutationOptions<MutationFnParams> = {}) =>
  useCustomValueCreate({ ...props }, createCustomValueByField);
